module.exports = "/images/icon-image_white.png?26aeaedd6492e28c27d69355247d3005";